import { RecentTrades } from 'components/RecentTrades'
import { memo } from 'react'
import { useTickList } from 'store/orderbook/hooks'
import { useCurrentSpotSymbol } from 'store/spot/hooks'

export const SpotRecentTrades = memo(() => {
  const { name = '', baseScale = 0, quoteScale = 0 } = useCurrentSpotSymbol()
  const list = useTickList(name)

  return (
    <RecentTrades list={list} baseScale={baseScale} quoteScale={quoteScale} />
  )
})
